var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgRank2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 86C66.7482 86 86 66.7482 86 43C86 19.2518 66.7482 0 43 0C19.2518 0 0 19.2518 0 43C0 66.7482 19.2518 86 43 86Z",
    fill: "url(#paint0_radial_2560_12429)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9996 80.4024C63.6564 80.4024 80.402 63.6568 80.402 43C80.402 22.3433 63.6564 5.59766 42.9996 5.59766C22.3429 5.59766 5.59729 22.3433 5.59729 43C5.59729 63.6568 22.3429 80.4024 42.9996 80.4024Z",
    fill: "url(#paint1_radial_2560_12429)",
    stroke: "url(#paint2_radial_2560_12429)",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.243 48.194L25.1823 53.8903H61.9285L62.9738 47.0274C63.3223 44.7322 63.3147 42.3915 62.9511 40.0963L61.9209 33.6576L51.9219 43.3687L43.5516 29.5898L34.1283 43.8459L25.1823 34.3696L24.3036 39.3085C23.7733 42.2476 23.7506 45.2549 24.243 48.194Z",
    fill: "url(#paint3_linear_2560_12429)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3684 60.7868H27.7505C26.334 60.7868 25.1902 59.643 25.1902 58.2265V55.2344H61.9364V58.2265C61.9288 59.6354 60.785 60.7868 59.3684 60.7868Z",
    fill: "url(#paint4_linear_2560_12429)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9364 53.8984H25.1902V55.2392H61.9364V53.8984Z",
    fill: "url(#paint5_linear_2560_12429)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1906 37.7254C27.4371 37.7254 29.2583 35.9042 29.2583 33.6576C29.2583 31.411 27.4371 29.5898 25.1906 29.5898C22.944 29.5898 21.1228 31.411 21.1228 33.6576C21.1228 35.9042 22.944 37.7254 25.1906 37.7254Z",
    fill: "url(#paint6_radial_2560_12429)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2957 35.2957C45.5422 35.2957 47.3634 33.4745 47.3634 31.2279C47.3634 28.9814 45.5422 27.1602 43.2957 27.1602C41.0491 27.1602 39.2279 28.9814 39.2279 31.2279C39.2279 33.4745 41.0491 35.2957 43.2957 35.2957Z",
    fill: "url(#paint7_radial_2560_12429)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4009 38.3113C63.6474 38.3113 65.4686 36.4901 65.4686 34.2435C65.4686 31.997 63.6474 30.1758 61.4009 30.1758C59.1543 30.1758 57.3331 31.997 57.3331 34.2435C57.3331 36.4901 59.1543 38.3113 61.4009 38.3113Z",
    fill: "url(#paint8_radial_2560_12429)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2560_12429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.4597 41.7327) scale(58.4355)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2560_12429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9984 42.9988) scale(37.3987)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2560_12429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9984 42.9988) scale(38.5553)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#C7C7C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2560_12429",
    x1: 43.5588,
    y1: 18.0105,
    x2: 43.5588,
    y2: 57.3504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#C8C5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0C0C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2560_12429",
    x1: 37.7193,
    y1: 49.7886,
    x2: 37.7193,
    y2: 61.8588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#B0B0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2560_12429",
    x1: 55.8246,
    y1: 54.3169,
    x2: 28.6667,
    y2: 54.3169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.430556,
    stopColor: "#75706B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#989593",
    stopOpacity: 0.506944
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2560_12429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8947 33.9452) rotate(-45) scale(4.26745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#ACACAC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2560_12429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.9998 31.5156) rotate(-45) scale(4.26745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#ACACAC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2560_12429",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.1051 34.5312) rotate(-45) scale(4.26745)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3747,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#ACACAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRank2);
export default __webpack_public_path__ + "static/media/img_rank2.e2de7ccf2e427158498f89e1ef4f4ed7.svg";
export { ForwardRef as ReactComponent };